import Modal from 'views/components/UI/Modal'
import { Button, ButtonBack, ButtonContainer, Container, DatePickerWrapper, Message, Title } from './style'
import { FC, useState } from 'react'
import DatePicker from 'views/components/UI/Datepicker'
import dayjs from 'dayjs'

interface ModalDateFilterProps {
  showConfirmModal: boolean
  setShowModal: (e: boolean) => void
  selectedProcessCount: number
  downloadFunction: (dates: { initDate: string; endDate: string }) => Promise<'success' | 'empty' | 'error'>
}

const ModalDateFilter: FC<ModalDateFilterProps> = ({ showConfirmModal, setShowModal, selectedProcessCount, downloadFunction }) => {
  const [initDate, setInitDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleBackButtonClick = () => {
    setShowModal(false)
  }

  const handleSaveButtonClick = async () => {
    if (loading) return
    if (!initDate || !endDate) {
      setMessage('Selecciona ambas fechas.')
      return
    }
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(initDate) || !/^\d{2}\/\d{2}\/\d{4}$/.test(endDate) ||
      !dayjs(initDate).isValid() || !dayjs(endDate).isValid() ||
      dayjs(initDate).format('MM/DD/YYYY') !== initDate || dayjs(endDate).format('MM/DD/YYYY') !== endDate) {
      setMessage('Introduce fechas válidas.')
      return
    }
    if (dayjs(initDate).isAfter(dayjs(endDate))) {
      setMessage('La fecha inicial debe ser anterior o igual a la final.')
      return
    }

    setMessage('')
    setLoading(true)
    try {
      const result = await downloadFunction({ initDate, endDate })
      if (result === 'success') {
        setShowModal(false)
      } else {
        setMessage(result === 'empty' ? 'No hay registros para ese rango. Puedes cambiar las fechas.' : 'No se pudo generar el resumen. Inténtalo de nuevo.')
      }
    } catch {
      setMessage('No se pudo generar el resumen. Inténtalo de nuevo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal styleContent={{ width: '350px' }} show={showConfirmModal} setShow={setShowModal}>
      <Container>
        <Title>Descargar resumen por fecha</Title>
        <DatePickerWrapper>
          <DatePicker
            defaultValue={String(new Date())}
            label="Fecha inicial"
            format='MM/DD/YYYY'
            value={initDate}
            onChange={(date) => { setInitDate(date); setMessage('') }}
          />
          <DatePicker
            defaultValue={String(new Date())}
            label="Fecha final"
            format='MM/DD/YYYY'
            value={endDate}
            onChange={(date) => { setEndDate(date); setMessage('') }}
          />
        </DatePickerWrapper>
        <Message>El rango usa la fecha de creación del proceso.</Message>
        {selectedProcessCount > 0 && <Message>Se incluirán solo los {selectedProcessCount} procesos seleccionados.</Message>}
        {message && <Message role="alert">{message}</Message>}
        <ButtonContainer>
          <ButtonBack onClick={handleBackButtonClick}>Cerrar</ButtonBack>
          <Button onClick={handleSaveButtonClick} type="button" disabled={loading}>{loading ? 'Buscando...' : 'Aplicar'}</Button>
        </ButtonContainer>
      </Container>
    </Modal>
  )
}

export default ModalDateFilter
